export default "__VITE_ASSET__hMoaDQ91__"